import { ReactNode } from 'react';
import { StyledFeatureBox } from './FeatureBox.styles';
import {
  Text,
  TokenTextAppearance,
  TextTag,
} from '@volkswagen-onehub/components-core';
import { FeatureStatus } from '@/hooks/useFeatures';

export interface FeatureBoxProps {
  children: ReactNode;
  status: FeatureStatus;
}

function FeatureBox({ children, status }: FeatureBoxProps) {
  return (
    <StyledFeatureBox status={status}>
      <Text tag={TextTag.p} appearance={TokenTextAppearance.copy200}>
        {children}
      </Text>
    </StyledFeatureBox>
  );
}

export default FeatureBox;
